import poweredByGoogle from '../assets/brand/powered-by-google.png';

// GoogleAttribution: Pflichthinweis, wenn Ergebnisse der Places API ohne Google-Karte angezeigt werden.
export function GoogleAttribution() {
  return <img className="google-attribution" src={poweredByGoogle} alt="Powered by Google" width={120} height={14} />;
}

// GoogleMapsAttribution: Pflichthinweis „Google Maps“ für Fahrzeiten und Koordinaten von Google Maps Platform, die
// nicht auf einer Google-Karte erscheinen (Attribution-Richtlinien: Text unverändert, nicht übersetzen, 12–16 px).
export function GoogleMapsAttribution({ label }: { label?: string }) {
  return (
    <span className="gmp-attribution-line">
      {label && <span className="muted">{label} </span>}
      <span className="gmp-attribution" translate="no" aria-label="Google Maps">
        Google Maps
      </span>
    </span>
  );
}
